{
  "shell.couldNotVerify.body": "Jäsenyytesi varmistaminen ei juuri nyt onnistunut. Yritä kirjautua uudelleen hetken kuluttua.",
  "shell.couldNotVerify.heading": "Jäsenyyttä ei voitu varmistaa",
  "shell.couldNotVerify.logout": "Kirjaudu ulos",
  "shell.couldNotVerify.retry": "Yritä uudelleen",
  "shell.desktopSidebar.navLabel": "Sivuvalikko",
  "shell.desktopSidebar.homeLink": "Etusivulle",
  "shell.desktopSidebar.languageSwitcher.label": "Vaihda kieli",
  "shell.desktopSidebar.feeOverdueMarker": "Jäsenmaksu maksamatta",
  "shell.desktopSidebar.opensInNewTab": "avautuu uuteen välilehteen",
  "shell.footer.copy": "Oma+ — esiversio, ei tuotantoa.",
  "shell.noMembershipBlock.benefit1": "Lakikaverin työsuhdepulmiin",
  "shell.noMembershipBlock.benefit2": "Vapaa-ajan tapaturmavakuutuksen kotimaahan ja ulkomaille",
  "shell.noMembershipBlock.benefit3": "Ammatillisen oikeusturva- ja vastuuvakuutuksen",
  "shell.noMembershipBlock.benefit4": "Tuhansia verkkokoulutuksia",
  "shell.noMembershipBlock.benefit5": "Henkilökohtaista uravalmennusta",
  "shell.noMembershipBlock.benefit6": "Monipuolisia alennuksia esimerkiksi hotelleista, liikuntaeduista ja tietoturvasta",
  "shell.noMembershipBlock.benefitsIntro": "YTK Työelämän jäsenenä saat:",
  "shell.noMembershipBlock.body": "Sinulla ei ole voimassa olevaa YTK Työelämän jäsenyyttä, joten palvelun käyttö ei ole mahdollista.",
  "shell.noMembershipBlock.heading": "Ei YTK Työelämän jäsenyyttä",
  "shell.noMembershipBlock.joinLinkLabel": "ytkpalvelut.fi/liity-jaseneksi",
  "shell.noMembershipBlock.joinPrefix": "Voit liittyä YTK Työelämän jäseneksi osoitteessa ",
  "shell.noMembershipBlock.logout": "Kirjaudu ulos",
  "shell.menu.close": "Sulje valikko",
  "shell.menu.cms": "CMS",
  "shell.menu.description": "Toissijainen valikko: palvelunavigaatio, kieli, uloskirjautuminen ja CMS-linkki.",
  "shell.menu.languagePicker.label": "Kieli",
  "shell.menu.languagePicker.fi": "Suomi",
  "shell.menu.languagePicker.en": "English",
  "shell.menu.languagePicker.sv": "Svenska",
  "shell.menu.legal.privacyPolicy": "Tietosuojaseloste",
  "shell.menu.legal.termsOfUse": "Sivuston käyttöehdot",
  "shell.menu.lakikaveri.children.lakiruutu": "Lakiruutu",
  "shell.menu.lakikaveri.children.oikeusturvavakuutus": "Oikeusturvavakuutus",
  "shell.menu.lakikaveri.children.tutustuLakikaveriin": "Tutustu Lakikaveriin",
  "shell.menu.lakikaveri.label": "Lakikaveri",
  "shell.menu.navLabel": "Sivuston toiminnot",
  "shell.menu.otaYhteytta.label": "Ota yhteyttä",
  "shell.menu.palvelutEdut.children.edutAlennukset": "Edut ja alennukset",
  "shell.menu.palvelutEdut.children.verkkokoulutuspalvelu": "Verkkokoulutuspalvelu",
  "shell.menu.palvelutEdut.label": "Jäsenyys ja edut",
  "shell.menu.signIn": "Kirjaudu sisään",
  "shell.menu.signOut": "Kirjaudu ulos",
  "shell.menu.submenuSuffix": "alavalikko",
  "shell.menu.tapaturmavakuutus.label": "Tapaturmavakuutus",
  "shell.menu.title": "Valikko",
  "shell.menu.userChip.demoBadge": "demo",
  "shell.menu.userChip.memberNumberPrefix": "Jäsennumero:",
  "shell.menu.userChip.openProfile": "Avaa Omat tiedot",
  "shell.primaryNav.koti": "Koti",
  "shell.primaryNav.label": "Päänavigaatio",
  "shell.primaryNav.omatTiedot": "Omat tiedot",
  "shell.primaryNav.unreadBadge": "Lukemattomia viestejä: {n}",
  "shell.primaryNav.viestit": "Viestit",
  "shell.session.signingOut": "Kirjaudutaan ulos…",
  "shell.session.signOutFailed": "Uloskirjautuminen epäonnistui. Istuntosi voi olla yhä voimassa. Yritä kirjautua ulos uudelleen.",
  "shell.session.retrySignOut": "Yritä uloskirjautumista uudelleen",
  "shell.session.accountReplaced": "Toinen tili kirjautui sisään tässä selaimessa. Sivu ladataan uudelleen…",
  "shell.session.reload": "Lataa sivu uudelleen",
  "shell.session.loading": "Tarkistetaan kirjautumista…",
  "shell.skipLink.label": "Siirry pääsisältöön",
  "shell.topBar.menuLabel": "Avaa valikko"
}
